import React, { useState } from 'react';
import { Copy, Download } from 'lucide-react';
import { useToast } from '../../ToastNotifications';

export const CopyButtons = ({ getCss, getSvg, getPalette, title = "" }) => {
    const [copied, setCopied] = useState("");
    const { showCopyToast, showDownloadToast } = useToast();

    const copyToClipboard = async (text, type) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(type);
            showCopyToast(title, type);
            setTimeout(() => setCopied(""), 2000);
        } catch (err) {
            console.error("Failed to copy: ", err);
        }
    };

    const downloadFile = (content, filename, contentType) => {
        const blob = new Blob([content], { type: contentType });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        const format = filename.split('.').pop();
        showDownloadToast(title, format);
    };

    return (
        <div className="flex flex-wrap gap-2 mt-3 pt-3 border-t border-gray-200 dark:border-gray-600">
            <button
                onClick={() => copyToClipboard(getCss(), "css")}
                className={`flex items-center px-3 py-1.5 text-xs rounded-md transition-all duration-200 ${copied === "css"
                    ? "bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                    }`}
            >
                <Copy className="w-3 h-3 mr-1" />
                {copied === "css" ? "Copied!" : "Copy CSS"}
            </button>

            <button
                onClick={() => copyToClipboard(getSvg(), "svg")}
                className={`flex items-center px-3 py-1.5 text-xs rounded-md transition-all duration-200 ${copied === "svg"
                    ? "bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                    }`}
            >
                <Copy className="w-3 h-3 mr-1" />
                {copied === "svg" ? "Copied!" : "Copy SVG"}
            </button>

            <button
                onClick={() => copyToClipboard(getPalette(), "palette")}
                className={`flex items-center px-3 py-1.5 text-xs rounded-md transition-all duration-200 ${copied === "palette"
                    ? "bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                    }`}
            >
                <Copy className="w-3 h-3 mr-1" />
                {copied === "palette" ? "Copied!" : "Copy Palette"}
            </button>

            <button
                onClick={() => downloadFile(getSvg(), `${title}-palette.svg`, "image/svg+xml")}
                className="flex items-center px-3 py-1.5 text-xs bg-blue-100 text-blue-700 hover:bg-blue-200 dark:bg-blue-900 dark:text-blue-300 dark:hover:bg-blue-800 rounded-md transition-all duration-200"
            >
                <Download className="w-3 h-3 mr-1" />
                Download SVG
            </button>
        </div>
    );
};